// Mock data for GET api/fmstasking/v1/mr/workshop/work-orders (FRNT-5926),
// shaped to let the wshop landing screen flow be built/tested before the
// real endpoint is wired in.
export const mockWorkshopWorkOrders = [
	{
		id: 4471,
		code: "WO20260818_L174FD",
		plateNumber: "SMS1000Z",
		makeAndModel: "Mazda 3",
		status: "InWorkshop",
		createdAt: "2026-08-18T05:38:00Z",
		enteredWorkshopAt: "2026-08-18T05:38:00Z",
		appointmentStart: "2026-08-20T01:00:00Z",
		updatedAt: "2026-08-21T11:30:00Z",
		issues: [
			{
				id: 2,
				code: "IS20260731_BXJ46C",
				serviceCategory: "Bodywork",
				issueType: { id: 1, name: "Front bumper" },
				issueDescription:
					"Front bumper broken due collision with pillar",
				outcome: null,
				unfixedReason: null,
			},
			{
				id: 5,
				code: "IS20260731_BXJ66C",
				serviceCategory: "Maintenance",
				issueType: { id: 2, name: "Left headlight" },
				issueDescription: "Headlight bulb wiring",
				outcome: null,
				unfixedReason: null,
			},
			{
				id: 15,
				code: "IS20260731_BXJ99E",
				serviceCategory: "Maintenance",
				issueType: { id: 9, name: "Tyres" },
				issueDescription: "Worn rear tyres need replacing",
				outcome: null,
				unfixedReason: null,
			},
		],
	},
	{
		id: 4468,
		code: "WO20260725_A912BC",
		plateNumber: "SRT5641A",
		makeAndModel: "Suzuki Swift Hybrid 3rd Gen",
		status: "InWorkshop",
		createdAt: "2026-07-20T02:00:00Z",
		enteredWorkshopAt: "2026-07-20T02:00:00Z",
		appointmentStart: "2026-07-22T02:00:00Z",
		updatedAt: "2026-07-25T15:00:00Z",
		issues: [
			{
				id: 11,
				code: "IS20260718_ZZ103C",
				serviceCategory: "Bodywork",
				issueType: { id: 3, name: "Rear bumper" },
				issueDescription: "Scratch on rear bumper",
				outcome: null,
				unfixedReason: null,
			},
		],
	},
	{
		id: 4450,
		code: "WO20260701_M301XY",
		plateNumber: "SMK3424D",
		makeAndModel: "Ssangyong Tivoli",
		status: "InWorkshop",
		createdAt: "2026-06-28T09:00:00Z",
		enteredWorkshopAt: "2026-06-28T09:00:00Z",
		appointmentStart: "2026-06-30T09:00:00Z",
		updatedAt: "2026-07-05T12:00:00Z",
		issues: [
			{
				id: 12,
				code: "IS20260625_QW881A",
				serviceCategory: "Maintenance",
				issueType: { id: 4, name: "Engine service" },
				issueDescription: "Scheduled engine servicing",
				outcome: null,
				unfixedReason: null,
			},
		],
	},
];
